import knightsConstantRedux from "../constant";
const initialPermissions = {
  permission: {},
  user: {},
  sessionTime: "",
  accessToken: null,
};
const appPermissions = (state = initialPermissions, action, root) => {
  switch (action.type) {
    case knightsConstantRedux.SET_PERMISSIONS:
      return {
        ...state,
        permission: action.payload.permission,
      };
    case knightsConstantRedux.SET_USER_LOGIN:
      return {
        ...state,
        user: action.payload.user,
        sessionTime: action.payload.sessionTime,
      };
    case knightsConstantRedux.UPDATE_LANG:
      return {
        ...state,
        user: {
          ...state.user,
          lang: action.payload.lang,
          dir: action.payload.dir,
        },
      };
    case knightsConstantRedux.SET_USER_LOGOUT:
      return {
        permission: {},
        user: {},
        sessionTime: "",
        accessToken: null,
      };
    case knightsConstantRedux.UPDATE_USER_PROPERTY:
      return {
        ...state,
        user: {
          ...state.user,
          [action.payload.property]: action.payload.value,
        },
      };
    case knightsConstantRedux.SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };
    case knightsConstantRedux.CLEAR_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: null,
      };

    default:
      return state;
  }
};
export default appPermissions;
